import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const cropTypeMessages = {
  Carrot: msg`Carrot`,
  Potato: msg`Potato`,
  Strawberry: msg`Strawberry`,
  Celery: msg`Celery`,
  Spinach: msg`Spinach`,
  "Sweet Pepper": msg`Sweet Pepper`,
  Tomato: msg`Tomato`,
  Cucumber: msg`Cucumber`,
  Zucchini: msg`Zucchini`,
  Eggplant: msg`Eggplant`,
  Broccoli: msg`Broccoli`,
  Cauliflower: msg`Cauliflower`,
  Cabbage: msg`Cabbage`,
  Radish: msg`Radish`,
  Beetroot: msg`Beetroot`,
  Parsnip: msg`Parsnip`,
  Pumpkin: msg`Pumpkin`,
  "Winter Squash": msg`Winter Squash`,
  Watermelon: msg`Watermelon`,
  "Green Beans": msg`Green Beans`,
  "Peas (fresh)": msg`Peas (fresh)`,
  "Table Grape": msg`Table Grape`,
  "Wine Grape": msg`Wine Grape`,
  Olive: msg`Olive`,
  Lettuce: msg`Lettuce`,
  Groundnut: msg`Groundnut`,
  Citrus: msg`Citrus`,
  Almond: msg`Almond`,
  Garlic: msg`Garlic`,
  Onion: msg`Onion`,
  Peach: msg`Peach`,
  Pear: msg`Pear`,
  "Spring Onions": msg`Spring Onions`,
  Plum: msg`Plum`,
  Apricot: msg`Apricot`,
  Kiwi: msg`Kiwi`,
  Pistachio: msg`Pistachio`,
  Walnut: msg`Walnut`,
  "Alfalfa (hay)": msg`Alfalfa (hay)`,
  "Maize (grain)": msg`Maize (grain)`,
  Wheat: msg`Wheat`,
  Barley: msg`Barley`,
  Rapeseed: msg`Rapeseed`,
  "Turfgrass (cool season)": msg`Turfgrass (cool season)`,
  "Turfgrass (warm season)": msg`Turfgrass (warm season)`,
  Apple: msg`Apple`,
} as const;

export function translateCropTypeName(cropTypeName?: string | null) {
  if (!cropTypeName) {
    return "";
  }

  const message = cropTypeMessages[cropTypeName as keyof typeof cropTypeMessages];

  return message ? i18n._(message) : cropTypeName;
}
